/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Complete helper functions for generating Python for
 *     blocks.  This is the entrypoint for python_compressed.js.
 * @suppress {extraRequire}
 */
'use strict';

goog.module('Blockly.Python.all');

const moduleExports = goog.require('Blockly.Python');
goog.require('Blockly.Python.colour');
goog.require('Blockly.Python.lists');
goog.require('Blockly.Python.logic');
goog.require('Blockly.Python.loops');
goog.require('Blockly.Python.math');
goog.require('Blockly.Python.procedures');
goog.require('Blockly.Python.texts');
goog.require('Blockly.Python.variables');
goog.require('Blockly.Python.variablesDynamic');

exports = moduleExports;
